import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore, type AdminRole } from "@/features/auth/stores/authStore";

/**
 * Guarda de rota por papel (defesa em profundidade — o backend é a autoridade).
 * Bloqueia (não só esconde) o acesso direto por URL a quem não tem o papel.
 */
export function RequireRole({ anyOf, children }: { anyOf: AdminRole[]; children: ReactNode }) {
  const role = useAuthStore((s) => s.user?.role);
  const allowed = role !== undefined && anyOf.includes(role);

  // Sem permissão: manda para o dashboard (acessível a qualquer admin).
  return allowed ? <>{children}</> : <Navigate to="/dashboard" replace />;
}
